import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../../contexts/UserContext';
import { useEffect } from 'react';

const Logout = () => {
  const { removeUserInfo } = useUserContext();
  const navigate = useNavigate();

  useEffect(() => {
    removeUserInfo();
    navigate('/signIn', { replace: true });
  }, []);

  return <></>;
};

export default Logout;
